import allianz from '../assets/images/companies-logos/allianz_64x48.png'
import cpp from '../assets/images/companies-logos/cpp_64x48.png'
import csob from '../assets/images/companies-logos/csob_64x48.png'
import direct from '../assets/images/companies-logos/direct_64x48.png'
import fortegra from '../assets/images/companies-logos/fortegra_64x48.png'
import generali from '../assets/images/companies-logos/generali_64x48.png'
import hvp from '../assets/images/companies-logos/hvp_64x48.png'
import kooperativa from '../assets/images/companies-logos/kooperativa_64x48.png'
import pillow from '../assets/images/companies-logos/pillow_64x48.png'
import slavia from '../assets/images/companies-logos/slavia_64x48.png'
import uniqa from '../assets/images/companies-logos/uniqa_64x48.png'
import uniqa_axa from '../assets/images/companies-logos/uniqa-axa2.png'
import vzp from '../assets/images/companies-logos/vzp_64x48.png'
import das from '../assets/images/companies-logos/das.png'
import axa_assistance from '../assets/images/companies-logos/axa-asistance.png'
import colonnade from '../assets/images/companies-logos/colonnade.svg'

interface Logos {
  [index: string]: string
}

export const logos: Logos = {
  1: uniqa,
  2: kooperativa,
  3: allianz,
  5: cpp,
  6: generali,
  7: direct,
  8: csob,
  9: uniqa_axa,
  10: slavia,
  11: hvp,
  12: vzp,
  13: fortegra,
  14: pillow,
  16: colonnade,
  17: axa_assistance,
  18: das,
}
